import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { WithDot } from '@/components-latest/primitives/Badge'
import Button from '@/components-latest/primitives/Button'
import Filter from '@/components-latest/primitives/Icons/Filter'
import { FilterWidgets } from '@/components-latest/ui/OrdersPage/FilterSearchToolbar/FilterWidgets'
import OrdersFilter from '@/components-latest/ui/OrdersPage/OrdersFilter'
import OrdersSearchInput, {
  IOrderHistorySearchCategory
} from '@/components-latest/ui/OrdersPage/OrdersSearchInput'
import {
  selectHasFilters,
  selectOrderFilters
} from '@/ducks/orders/selectors/orders.selectors'
import {
  removeOrderFilter,
  setOrderSearchParams
} from '@/ducks/orders/slices/orders.slice'

import Styles from './FilterSearchToolbar.module.scss'

const FilterSearchToolbar = () => {
  const dispatch = useDispatch()

  const filters = useSelector(selectOrderFilters)
  const hasFilters = useSelector(selectHasFilters)

  const [searchValue, setSearchValue] = useState('')
  const [searchCategory, setCategorySearchValue] = useState<
    IOrderHistorySearchCategory | ''
  >('')

  const handleSearchInputChange = (
    value: string,
    category: IOrderHistorySearchCategory | ''
  ) => {
    setSearchValue(value)
    setCategorySearchValue(category)
  }

  const updateFilters = useCallback(
    (searchValue: string, categoryValue: IOrderHistorySearchCategory | '') => {
      dispatch(
        setOrderSearchParams({
          value: searchValue,
          category: categoryValue
        })
      )
    },
    [dispatch]
  )

  const handleFilterRemove = (name: string | string[]) => {
    dispatch(removeOrderFilter(name))
  }

  return (
    <div
      className={Styles.filterSearchToolbar}
      data-testid="filter-search-toolbar">
      <div className={Styles.bar}>
        <OrdersSearchInput
          value={searchValue}
          isLoading={false}
          category={searchCategory}
          onSubmit={updateFilters}
          onChange={handleSearchInputChange}
          id="OrdersSearchInput"
        />
        <OrdersFilter>
          <Button
            variant="secondary"
            size="large"
            icon={
              <WithDot variant={hasFilters ? 'negative' : 'hidden'}>
                <Filter />
              </WithDot>
            }
          />
        </OrdersFilter>
      </div>
      <div className={Styles.appliedFilters}>
        <FilterWidgets filters={filters} onClick={handleFilterRemove} />
      </div>
    </div>
  )
}

export default FilterSearchToolbar
